export default __webpack_public_path__ + "static/media/congragulationicon.016ac63f.svg";